export function tooltipEnable()
{
    $('[data-tooltip="tooltip"]').tooltip();
}